import React from "react";
import Modal from "react-bootstrap/Modal";
import { ImgWithFallback } from "../ImgWithFallback/ImgWithFallback";

/**
 * Shared modal component for displaying product or Axys details
 * Can display video, image, description, and a learn more button
 */
export const ProductDetailsModal = ({ show, modalDetails, onHide, className = "ProductDetailsModal" }) => (
  <Modal className={className} show={show} size="md" style={{ zIndex: 2002 }} onHide={onHide} keyboard={false}>
    <Modal.Header closeButton>
      <Modal.Title>{modalDetails.title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className="d-flex flex-column">
        {modalDetails?.youtubeSrc && (
          <iframe
            className="mx-auto my-4 d-block"
            style={{ width: "700px", maxWidth: "100%", aspectRatio: "16/9" }}
            src={modalDetails.youtubeSrc}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          ></iframe>
        )}
        {(modalDetails?.image || modalDetails?.imageSrc) && (
          <ImgWithFallback
            src={modalDetails.image || modalDetails.imageSrc}
            fallback={modalDetails.image ? `${modalDetails.image.split(".")[0]}.png` : `${modalDetails.imageSrc.split(".")[0]}.png`}
            alt={modalDetails.title}
            className="mx-auto my-4 w-100"
          />
        )}
        {modalDetails.description && (
          <>
            <h5 className="mb-2">Description</h5>
            <p className="description">{modalDetails.description}</p>
          </>
        )}
        {modalDetails.productPage && (
          <a href={modalDetails.productPage} target="_blank" rel="noopener noreferrer" className="btn btn-primary mx-auto mt-1 mt-md-4">
            Learn More
          </a>
        )}
      </div>
    </Modal.Body>
  </Modal>
);
